export const generateWebsiteLink = (website) => {
  if (!website) {
    return null;
  }
  return /(http(s?)):\/\//i.test(website) ? website : `https://${website}`;
};
